import { initPlatform } from './export/platform-export'
import { initSubscribe } from './export/subevent-export'
import { initMedia } from './export/media-export'
import { initOnline } from './export/online-export'
import { initEnums} from './export/enums-export'
import { initMessage } from "./export/message-export"
import LiveEngine from './live'
import 'webrtc-adapter'
import Store from 'util/store'
import './style/index.css'

function HstRtcEngine() {
  if (process.env.NODE_ENV !== "production" && !(this instanceof HstRtcEngine)) {
    console.error("HstRtcEngine is a constructor and should be called with the `new` keyword");
  }
}

initSubscribe(HstRtcEngine);
initPlatform(HstRtcEngine);
initMedia(HstRtcEngine);
initOnline(HstRtcEngine);
initEnums(HstRtcEngine);
initMessage(HstRtcEngine);
HstRtcEngine.Store = Store
HstRtcEngine.LiveEngine = LiveEngine
export default HstRtcEngine;